export default function EditorialStatement() {
  return (
    <section className="bg-[#F7F6F2] text-[#0A0A0A]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-28 lg:py-40">
        <p className="font-mono-tech text-[11px] uppercase tracking-[0.3em] text-[#0A0A0A] mb-10">
          Who We Are
        </p>
        <h2
          data-testid="editorial-statement-heading"
          className="font-heading font-light uppercase tracking-tight leading-[1.05] text-4xl sm:text-5xl lg:text-7xl max-w-5xl"
        >
          Sport creates attention.
          <br />
          We turn it into partnerships<span className="text-[#0A0A0A]">.</span>
        </h2>

        <div
          data-testid="editorial-statement-body"
          className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-10 max-w-4xl"
        >
          <p className="text-base sm:text-lg font-light text-neutral-700 leading-relaxed">
            QUALIVE works across Formula One and football to identify,
            structure and deliver commercially valuable partnerships between
            brands and rights holders.
          </p>
          <p className="text-base sm:text-lg font-light text-neutral-700 leading-relaxed">
            We combine commercial insight, relationships and an understanding
            of global sport to create partnerships that make sense on both
            sides.
          </p>
        </div>

        <div
          data-testid="brand-ethos-badge"
          className="mt-16 pt-8 border-t border-black/10 flex flex-col sm:flex-row gap-4 sm:gap-12"
        >
          <span className="font-mono-tech text-[11px] uppercase tracking-[0.25em] text-neutral-500">
            Quali — the lap that sets the grid
          </span>
          <span className="font-mono-tech text-[11px] uppercase tracking-[0.25em] text-neutral-500">
            Live — the moment it matters
          </span>
        </div>
      </div>
    </section>
  );
}
